<template>
  <div class="finance-enroll-fee-list"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <div class="header">
      <div class="label">
        <span class="custom-label">招生批次</span>
        <el-select v-model="batchId"
                   size="mini"
                   filterable>
          <el-option v-for="val in batchList"
                     :key="val.id"
                     :label="val.name"
                     :value="val.id"/>
        </el-select>
      </div>
    </div>
    <div class="main">
      <div class="main-cont" v-if="batchId">
        <keep-alive>
          <TemplateDataGrid :key="batchId" :batchId="batchId"
                            gridId="EnrollFeeStudentList"></TemplateDataGrid>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import TemplateDataGrid from '../../../../../templates/TemplateDataGrid'

export default {
  name: 'PlatDataPanelSelect',
  components: {TemplateDataGrid},
  data () {
    return {
      loading: false,
      batchId: '',
      batchList: []
    }
  },
  methods: {
    loadData () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/finance/enrollFeeManage/enrollBatchList',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.batchList = response.data.batchList || []
              if (this.batchList.length) {
                this.batchId = this.batchList[0].id
              }
              break
            }
            default: {
              this.batchList = []
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss">
.finance-enroll-fee-list {
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  & > .header {
    flex: none;
    height: 46px;
    padding: 0 15px;
    line-height: 46px;
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    border-bottom: 1px solid #ebeef5;
    & > .label {
      flex: auto;
      display: flex;
      align-items: center;
      white-space: nowrap;
      .custom-label {
        margin-right: 8px;
        font-size: 13px;
      }
      .el-select {
        width: 260px;
      }
    }
  }
  & > .main {
    flex: auto;
    position: relative;
    & > .main-cont {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }
  }
}
</style>
